import { customTextBlock, paragraph } from "../../../text/nodes"
import { Quote as QuoteEditor } from "./quote"
import { QuoteSettings } from "./quote-settings"
import QuotePreview from "./quote-preview.png"
import { getFont } from "../../../shared/fonts"

export const Quote = {
  name: "Quote",
  label: "Quote with attribution",
  EditorComponent: QuoteEditor,
  SettingsComponent: QuoteSettings,
  image: QuotePreview,
  defaultProperties: {
    backgroundColor: "#FFFFFF",
    textColor: "#000000",
    textFontFamily: getFont("Arial"),
    textFontSize: 26,
    textLineHeight: 1.3,
    nameFontFamily: getFont("Courier New"),
    nameFontSize: 15,
    nameLineHeight: 1.3,
    paddingTop: 60,
    paddingRight: 40,
    paddingBottom: 60,
    paddingLeft: 40,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    borderColor: "#000000",
    borderTopWidth: 4,
    borderRightWidth: 4,
    borderBottomWidth: 4,
    borderLeftWidth: 4
  },
  defaultChildren: [
    customTextBlock([
      {
        object: "text",
        leaves: [
          {
            object: "leaf",
            text:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse aliquet interdum dui, sit amet dignissim nisi ornare vel.",
            marks: [
              {
                object: "mark",
                type: "bold",
                data: {}
              },
              {
                object: "mark",
                type: "italic",
                data: {}
              }
            ]
          }
        ]
      }
    ]),
    customTextBlock([paragraph("Name", { alignment: "center" })])
  ]
}
